import {
  Box,
  Button,
  Flex,
  Table,
  TableTbody,
  TableTd,
  TableTh,
  TableThead,
  TableTr,
  Title,
} from '@mantine/core';
import { WithRecords } from '../wrappers/WithRecords';
import { ApiKey, page, remove, update } from '../api/apiKeys';
import {
  IconLicense,
  IconPencil,
  IconPlus,
  IconTrash,
} from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';
import { ApiKeyFilter, ApiKeyFilters } from '../components/ApiKeyFilter';
import { useAPIKeyOrgs } from '../hooks/useAPIKeyOrgs';
import { useKnownApps } from '../hooks/useKnownApps';
import { useState } from 'react';
import { Date } from '../components/Date';

export const ApiKeys = () => {
  const [filters, setFilters] = useState<ApiKeyFilters>({
    $showDeleted: 'false',
  });
  const navigate = useNavigate();
  const { organisations } = useAPIKeyOrgs();
  const { knownApps } = useKnownApps();

  return (
    <Box>
      <Flex mr={12} justify="space-between">
        <Title order={3} mb={12}>
          API Keys
        </Title>
        <Button
          component="a"
          href="/api-keys/create"
          color="blue"
          leftSection={<IconPlus />}
        >
          Create API Key
        </Button>
      </Flex>
      <ApiKeyFilter
        organisations={organisations ?? []}
        knownApps={knownApps ?? []}
        onChange={(k, v) => setFilters({ ...filters, [k]: v })}
      />
      <WithRecords
        getPage={page}
        remove={remove}
        restore={async (token, id) =>
          update(token, id, {
            deletedAt: null,
          })
        }
        filters={filters}
        showDeleted={filters.$showDeleted === 'true'}
      >
        {(results, removeItem, restoreItem) => (
          <Table.ScrollContainer minWidth={500} mb="lg">
            <Table>
              <TableThead>
                <TableTr>
                  <TableTh>Key (License string)</TableTh>
                  <TableTh>Scope</TableTh>
                  <TableTh>Organisation</TableTh>
                  <TableTh>Contact</TableTh>
                  <TableTh>Active</TableTh>
                  <TableTh>Updated At</TableTh>
                  <TableTh>Created At</TableTh>
                  <TableTh></TableTh>
                </TableTr>
              </TableThead>
              <TableTbody>
                {results.map((result: ApiKey) => (
                  <TableTr key={result._id}>
                    <TableTd>
                      <strong>{result.userKey}</strong>
                    </TableTd>
                    <TableTd>
                      <Link to={`/apps/${result.scope}`}>{result.scope}</Link>
                    </TableTd>
                    <TableTd>{result.organisation}</TableTd>
                    <TableTd>{result.contact}</TableTd>
                    <TableTd>{result.deletedAt ? 'No' : 'Yes'}</TableTd>
                    <TableTd>
                      <Date isoString={result.updatedAt} />
                    </TableTd>
                    <TableTd>
                      <Date isoString={result.createdAt} />
                    </TableTd>
                    <TableTd>
                      <Flex justify="flex-end" gap="md">
                        <Button
                          component="a"
                          href={`/api-keys/${result._id}`}
                          leftSection={<IconPencil />}
                          color="blue"
                        >
                          Edit
                        </Button>
                        <Button
                          leftSection={<IconLicense />}
                          onClick={() =>
                            navigate(
                              `/api-keys/${encodeURIComponent(
                                result._id
                              )}/licenses`
                            )
                          }
                          color="blue"
                        >
                          Licenses
                        </Button>
                        {result.deletedAt ? (
                          <Button
                            color="green"
                            onClick={() => restoreItem(result._id)}
                          >
                            Restore
                          </Button>
                        ) : (
                          <Button
                            leftSection={<IconTrash />}
                            color="red"
                            onClick={() => removeItem(result._id)}
                          >
                            Remove
                          </Button>
                        )}
                      </Flex>
                    </TableTd>
                  </TableTr>
                ))}
              </TableTbody>
            </Table>
          </Table.ScrollContainer>
        )}
      </WithRecords>
    </Box>
  );
};
